import { fontSizes, lineHeights } from '../foundations/typography';

const Heading = {
  baseStyle: { color: 'text.primary', fontWeight: 700 },
  sizes: {
    h1: { fontSize: fontSizes.h1, lineHeight: lineHeights.tight },
    h2: { fontSize: fontSizes.h2, lineHeight: lineHeights.snug },
    h3: { fontSize: fontSizes.h3, lineHeight: lineHeights.snug },
  },
};

export default Heading;
